export default "__VITE_ASSET__CKf$asHn__"